import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';

interface DramaCardProps {
  drama: Drama;
  showSynopsis?: boolean;
  index?: number;
}

export default function DramaCard({ drama, showSynopsis = false, index = 0 }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title} 电视剧海报`}
          title={`${drama.title} 在线观看与剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 rounded-md bg-foreground-950/75 px-1.5 py-0.5 text-xs font-semibold text-accent-300">
          {drama.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 rounded-md bg-primary-500 px-1.5 py-0.5 text-xs font-medium text-background-50">
          更新至 {drama.latestEpisode} 集
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600">
          <span className="whitespace-nowrap">{drama.region}</span>
          <span className="text-foreground-300">·</span>
          <span className="whitespace-nowrap">{drama.year}</span>
          <span className="text-foreground-300">·</span>
          <span className="whitespace-nowrap">全 {drama.episodes} 集</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {drama.genres.map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
        {showSynopsis && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {drama.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}